<template>
  <div class="the-navbar__user-meta flex items-center" v-if="isLoggedIn">
    <div class="text-right leading-tight hidden sm:block">
      <p class="font-semibold">{{ userInfo.FullName }}</p>
      <small>{{ userInfo.Mail }}</small>
    </div>

    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
      <div class="con-img ml-3">
        <img
          v-if="userInfo.Picture"
          key="onlineImg"
          :src="userInfo.Picture"
          :alt="userInfo.FullName"
          width="40"
          height="40"
          class="rounded-full shadow-md cursor-pointer block"
        />
        <vs-avatar v-else class="rounded-full shadow-md cursor-pointer block" />
      </div>

      <vs-dropdown-menu class="vx-navbar-dropdown">
        <ul style="min-width: 9rem">
          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="logout"
          >
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">{{$t('User.Logout')}}</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>

export default {
  data() {
    return {
      userRole: this.$store.state.userRole
    };
  },
  computed: {
    isLoggedIn() {
      this.$store.state.userRole;
      let access = this.$auth.hasUserRole(
        this.$router.match(this.$route).meta.rule
      );
      if (!access) this.$router.push("/");

      return this.$store.state.auth.isUserLoggedIn();
    },
    activeUserInfo() {
      return this.$store.state.AppActiveUser;
    },
    userInfo() {
      this.$store.state.userRole;
      if (
        $cookies.isKey(process.env.VUE_APP_COOKIE_AUTH_UI) &&
        this.$auth.isAuthenticated()
      ) {
        return $cookies.get(process.env.VUE_APP_COOKIE_AUTH_UI);
      } else {
        return {};
      }
    }
  },
  methods: {
    handleLoginEvent(payload) {},
    logout() {
      if (this.isLoggedIn) {
        this.$auth.logOut();
        this.$router.push('/login');
      }
    }
  }
};
</script>
